import { LanguagePack, usePersistedState } from "@buzzeasy/shared-frontend-utilities";
import { PropsWithChildren, ReactElement } from "react";
import { TranslationOverrideContext } from "./TranslationOverrideContext";

/**
 * Provides the value for AgentUIContext.
 *
 * **No provider dependencies**
 */
export default function TranslationOverrideProvider({ children }: PropsWithChildren): ReactElement {
  const contextValue = usePersistedState<LanguagePack | null>(null, "aui-translationOverrideValues", sessionStorage);

  return (
    <TranslationOverrideContext.Provider value={contextValue}>
      {children}
    </TranslationOverrideContext.Provider>
  );
}
